export const HANGING_PROTOCOL_STORAGE_KEY = "kairos.hangingProtocols.v1";

const safeJson = (raw) => {
  try { return JSON.parse(raw); } catch { return null; }
};

export const loadHangingProtocolOverrides = () => {
  if (typeof window === "undefined") return [];
  const parsed = safeJson(window.localStorage.getItem(HANGING_PROTOCOL_STORAGE_KEY));
  return Array.isArray(parsed) ? parsed : [];
};

export const saveHangingProtocolOverrides = (protocols) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(HANGING_PROTOCOL_STORAGE_KEY, JSON.stringify(Array.isArray(protocols) ? protocols : []));
};
